/**
 * @file 新闻列表页tab
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import classNames from 'classnames';

import {INewsModule, ICategoryItem} from '../../type';


interface IProps {
    newsModule: INewsModule;
    categoryList: ICategoryItem[];
    currentCategory: ICategoryItem;
}

const CategoryList: React.FC<IProps> = props => {
    const categoryList = props.categoryList;
    const currentCategory = props.currentCategory;
    const newsModule = props.newsModule;

    return (
        <div className="paddle-news-tabs">
            {categoryList.map(category => (
                <a
                    key={category.id}
                    href={`/support/news?module=${newsModule.nSysKey || 1}&category=${category.id}`}
                    className={classNames(
                        `paddle-news-tabs-item`,
                        {'paddle-news-tabs-active': category.id === currentCategory.id}
                    )}
                >{category.catName}
                </a>
            ))}

        </div>
    );
};

export default CategoryList;
